import React from 'react'
import { Container } from './styles'

function Testimonials () {
  return (
    <Container>Ruta Testimonials</Container>
  )
}

export default Testimonials
